module.exports = __webpack_public_path__ + "static/media/imgLoading.5ae10eb0.gif";